export enum VossTierChangeOperation {
    Create = 0,
    Terminate = 1,
    Upgrade = 2,
    Sidegrade = 3,
    Downgrade = 4,
    Migration = 5,
}

export const VossTierChangeOperationText: Record<VossTierChangeOperation, string> = {
    [VossTierChangeOperation.Create]: 'vossTierChangeOperation.create',
    [VossTierChangeOperation.Terminate]: 'vossTierChangeOperation.terminate',
    [VossTierChangeOperation.Upgrade]: 'vossTierChangeOperation.upgrade',
    [VossTierChangeOperation.Sidegrade]: 'vossTierChangeOperation.sidegrade',
    [VossTierChangeOperation.Downgrade]: 'vossTierChangeOperation.downgrade',
    [VossTierChangeOperation.Migration]: 'vossTierChangeOperation.migration',
};

export const tierChangeOperations = Object.keys(VossTierChangeOperationText).map(Number) as VossTierChangeOperation[];
